import { Col, Row, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { Trans, useTranslation } from 'react-i18next';

import { withRouteChange } from '../services/APM';
import styles from './NotFound.module.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <main className={styles.main}>
      <Helmet>
        <title>
          {t('Ops! Página não encontrada')} | {t('Recrutamento e Seleção')}
        </title>
      </Helmet>
      <p className={styles.background_number_error}>404</p>
      <Row align="middle" justify="center" className={styles.row}>
        <Col span={16} className={styles.column}>
          <Typography.Title className={styles.title} level={2}>
            <Trans>Ops! Página não encontrada</Trans>
          </Typography.Title>
          <p>
            <Trans>
              Nos desculpe! A página que você tentou acessar está indisponível ou não existe.
            </Trans>
          </p>
          <p>
            <Trans>Lembre-se de verificar o link de acesso.</Trans>
          </p>
        </Col>
      </Row>
    </main>
  );
};

export default withRouteChange()(NotFound);
